import React from 'react';
import PageHeader from '../components/PageHeader';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  const lastUpdated = 'January 1, 2025';

  return (
    <div className="page-enter">
      <PageHeader title="Terms of Service" breadcrumbs={[{ label: 'Terms of Service' }]} />

      <div className="py-14 bg-background">
        <div className="max-w-4xl mx-auto px-4">
          <p className="text-sm text-muted-foreground mb-8">Last Updated: {lastUpdated}</p>

          <div className="prose max-w-none space-y-8 text-muted-foreground text-sm leading-relaxed">

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">1. Agreement to Terms</h2>
              <p>
                These Terms of Service ("Terms") constitute a legally binding agreement between you and B2BTechLeads ("Company," "we," "us," or "our") governing your access to and use of the website at <strong>b2btechleads.com</strong> and all related services, features, content, and functionality (collectively, the "Services").
              </p>
              <p className="mt-3">
                By accessing or using our Services, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you must not access the Services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">2. Description of Services</h2>
              <p>B2BTechLeads provides B2B lead generation, marketing outsourcing, and database marketing services, including but not limited to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Marketing Leads (telemarketing, email, postal, all-in-one)</li>
                <li>Technology Leads for IT and software companies</li>
                <li>Nurture Marketing programs</li>
                <li>Database Assessment and enrichment services</li>
                <li>Market Research and Survey services</li>
              </ul>
              <p className="mt-3">
                Specific service terms, deliverables, and pricing are governed by separate written service agreements entered into between B2BTechLeads and each client.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">3. Acceptable Use</h2>
              <p>You agree to use our Services only for lawful purposes and in accordance with these Terms. You agree not to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Use the Services in any way that violates applicable federal, state, local, or international law or regulation</li>
                <li>Transmit any unsolicited or unauthorized advertising or promotional material (spam)</li>
                <li>Impersonate any person or entity, or misrepresent your affiliation with any person or entity</li>
                <li>Attempt to gain unauthorized access to any portion of the Services or any related systems or networks</li>
                <li>Engage in any conduct that restricts or inhibits any other person's use or enjoyment of the Services</li>
                <li>Use any robot, spider, scraper, or other automated means to access the Services without our express written permission</li>
                <li>Introduce any viruses, Trojan horses, worms, or other malicious code</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">4. Intellectual Property</h2>
              <p>
                The Services and their entire contents, features, and functionality — including but not limited to all text, graphics, logos, button icons, images, audio clips, and software — are owned by B2BTechLeads or its licensors and are protected by United States and international copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>
              <p className="mt-3">
                You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our website without our prior written consent, except for your own personal, non-commercial use.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">5. Client Accounts and Responsibilities</h2>
              <p>
                If you access our Services as a client, you are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Provide accurate, current, and complete information when registering or submitting forms</li>
                <li>Notify us immediately of any unauthorized use of your account</li>
                <li>Ensure all users accessing Services through your account comply with these Terms</li>
                <li>Use leads and data provided strictly in accordance with applicable law, including CAN-SPAM and TCPA</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">6. Payment Terms</h2>
              <p>
                Fees for our services are as set forth in your individual service agreement. Unless otherwise agreed in writing:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>All fees are due within thirty (30) days of invoice date</li>
                <li>Late payments may incur interest at 1.5% per month or the maximum permitted by law</li>
                <li>All fees are non-refundable unless otherwise specified in your service agreement</li>
                <li>We reserve the right to suspend services for non-payment after providing written notice</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">7. Disclaimer of Warranties</h2>
              <p>
                THE SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. B2BTECHLEADS EXPRESSLY DISCLAIMS ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
              </p>
              <p className="mt-3">
                We do not warrant that (a) the Services will be uninterrupted or error-free, (b) results obtained from using the Services will be accurate or reliable, or (c) the quality of any information or services obtained through the Services will meet your expectations.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">8. Limitation of Liability</h2>
              <p>
                TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, B2BTECHLEADS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES — INCLUDING LOST PROFITS, LOST DATA, LOSS OF GOODWILL, OR BUSINESS INTERRUPTION — ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF OR INABILITY TO USE THE SERVICES.
              </p>
              <p className="mt-3">
                OUR TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING FROM OR RELATED TO THE SERVICES SHALL NOT EXCEED THE AMOUNT PAID BY YOU TO B2BTECHLEADS IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">9. Indemnification</h2>
              <p>
                You agree to defend, indemnify, and hold harmless B2BTechLeads and its officers, directors, employees, contractors, agents, licensors, and suppliers from any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms or your use of the Services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">10. Governing Law & Dispute Resolution</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the State of Florida, without regard to its conflict-of-law provisions. Any dispute arising from or relating to these Terms or the Services shall be resolved exclusively in the state or federal courts located in Sarasota County, Florida.
              </p>
              <p className="mt-3">
                You waive any objection to the jurisdiction of such courts and waive any claim that such courts constitute an inconvenient forum.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">11. Termination</h2>
              <p>
                We reserve the right to terminate or suspend your access to the Services at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users, us, third parties, or for any other reason.
              </p>
              <p className="mt-3">
                All provisions of these Terms which by their nature should survive termination shall survive, including ownership provisions, warranty disclaimers, indemnity, and limitations of liability.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">12. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. We will provide notice of significant changes by updating the "Last Updated" date at the top of this page. Your continued use of the Services after any such modifications shall constitute your acknowledgment of the modified Terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3 pb-2 border-b border-border">13. Contact Information</h2>
              <p>For questions about these Terms of Service, please contact us:</p>
              <div className="mt-3 bg-muted border border-border p-5 rounded-sm">
                <p className="font-semibold text-foreground">B2BTechLeads — Legal Department</p>
                <p>15 Business Ave, Suite 500, Orlando, FL 34236</p>
                <p>Phone: <a href="tel:941-799-8809" style={{ color: '#43a047' }} className="hover:underline">941-799-8809</a></p>
                <p>Email: <a href="mailto:info@b2btechleads.com" style={{ color: '#43a047' }} className="hover:underline">info@b2btechleads.com</a></p>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
